/**
 * Formats the given number into a price in US currency
 *
 * @param {Number} price the number to be formatted as a price string
 * @param {String} defaultValue value to be returned if the given number can not be formatted as a US price.
 *
 * @return {String} A string representing a US price
 */
function formatAsUsPrice(price, defaultValue) {
    var toReturn = '';
    if(typeof(price) == 'number' && !isNaN(price)) {
        if(price > 999999) {
            price = Math.ceil(price / 10000) / 100;
            toReturn = '$' + price + 'M';
        } else if(price > 999) {
            price = Math.floor(price * 100) / 100;
            price = /(\d+)(\d{3})/.exec(price);
            price.shift();
            toReturn = '$' + price.join(',');
        } else {
            toReturn = '$' + price;
        }
    } else {
        toReturn = defaultValue || '$NA';
    }

    return toReturn;
}

/**
 * numberWithCommas - Format number to number with commas
 * @param num
 * @param defaultValue
 * @returns {string}
 */
function numberWithCommas(num, defaultValue) {
    var toReturn = '';
    if(typeof(num) == 'number' && !isNaN(num)) {
        var parts = num.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        toReturn = parts.join('.');
    } else {
        toReturn = defaultValue || 'NA';
    }

    return toReturn;
}

function urlFriendlySpaces(str){
    return str.replace(/\s/g,'%20');
}

module.exports = {
    formatAsUsPrice: formatAsUsPrice,
    numberWithCommas: numberWithCommas,
    urlFriendlySpaces: urlFriendlySpaces
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/utils/string/string.js
// module id = 113
// module chunks = 0 1 6 16 19 23 28